import React from 'react';

import {DropdownSeparator} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownSeparator';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {PermissionSimpleDropdownItem} from '../../../common/dropdowns/permissionSimpleDropdownItem';
import {EditSidebarCopy} from '../editor/copy/edit-sidebar-copy';
import {HideInSidebarCopy} from '../editor/copy/hide-in-sidebar-copy';
import {WorkspaceLineMoreButton} from '../line/workspaceLineMoreButton';

/*
 * Props.
 */

export interface WorkspaceHeaderMoreDropdownRenderProps {
  /** Easy way to add items to the default simple dropdown. */
  extraItems?: React.ReactNode;
  /** Replace default text for "Hide in sidebar" item. */
  hideWorkspaceLabel?: React.ReactNode;
  /** Handler to hide workspace in sidebar. If undefined, the hide in sidebar option will not be rendered. */
  onHideWorkspace?: () => void;
  /** Handler to edit sidebar */
  onEditWorkspace: () => void;
}
export interface WorkspaceHeaderMoreProps extends WorkspaceHeaderMoreDropdownRenderProps {}

/*
 * Component.
 */

export const WorkspaceHeaderMore = (props: WorkspaceHeaderMoreProps) => (
  <PopoverCoordinator
    renderButton={renderDefaultButton}
    renderModal={(popoverTransferProps) => renderDefaultDropdown(popoverTransferProps, props)}
  />
);

/*
 * Helpers.
 */

function renderDefaultButton(isDropdownOpen: boolean) {
  return <WorkspaceLineMoreButton isMoreOpen={isDropdownOpen} />;
}

function renderDefaultDropdown(
  popoverTransferProps: PopoverTransferProps,
  dropdownItemProps: WorkspaceHeaderMoreDropdownRenderProps,
) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SimpleDropdown {...popoverTransferProps}>
      {renderWorkspaceHeaderMoreDefaultDropdownItems(dropdownItemProps)}
    </SimpleDropdown>
  );
}

export function renderWorkspaceHeaderMoreDefaultDropdownItems({
  extraItems,
  hideWorkspaceLabel,
  onHideWorkspace,
  onEditWorkspace,
}: WorkspaceHeaderMoreDropdownRenderProps) {
  return (
    <>
      {extraItems}
      {onHideWorkspace && (
        <>
          <PermissionSimpleDropdownItem onSelect={onHideWorkspace}>
            {hideWorkspaceLabel || <HideInSidebarCopy />}
          </PermissionSimpleDropdownItem>
          <DropdownSeparator />
        </>
      )}
      <PermissionSimpleDropdownItem onSelect={onEditWorkspace}>
        <EditSidebarCopy />
      </PermissionSimpleDropdownItem>
    </>
  );
}
